import { useLocation } from 'react-router-dom';
import { useGetTags } from 'domains/Auth/hooks';
import { UNLOCKED_ROUTE_PATTERNS } from '../constants';
import { BlockedType } from '../enums';

export function useNuvemPagoBlocking() {
  const tags = useGetTags();
  const { pathname } = useLocation();

  const blockedTypes = Object.values(BlockedType).filter((type) =>
    tags.includes(type),
  );

  const isBlocked = blockedTypes.length > 0;
  const shouldBlockRoute =
    isBlocked &&
    !UNLOCKED_ROUTE_PATTERNS.some((pattern) => pattern.test(pathname));

  return {
    shouldBlockRoute,
    blockedTypes,
    isBlocked,
  };
}
